import React from 'react'
import { useTranslation } from 'react-i18next'
import { CampaignState } from 'state/campaigns'
import { getSubmissionStatusOptions } from '../index'
import Text from 'particles/Text'
import styled from 'particles/themes/styled'

interface CampaignHeaderProps {
    className?: string
    campaign: CampaignState
}

const CampaignHeader: React.FC<CampaignHeaderProps> = ({ campaign, className }) => {
    const [t] = useTranslation()
    const submissionStatusOptions = getSubmissionStatusOptions(t)

    return (
        <div className={className}>
            <img className="brand-logo" src={campaign.brand.logo_image.image} alt="avatar" />
            <div>
                <Text scale="bodyS500">
                    {t('submission.review.campaignTitle', {
                        title: campaign.title,
                    })}
                </Text>
                <Text scale="bodyS500">
                    {t('submission.review.brandName', {
                        brand: campaign.brand,
                    })}
                </Text>
                <Text scale="bodyS500">
                    {t('submission.review.campaignType', {
                        campaignType: campaign.is_private
                            ? t('card.allCampaigns.privateCampaignLabel', 'Private Campaign')
                            : t('card.allCampaigns.publicCampaignLabel', 'Public Campaign'),
                    })}
                </Text>
                <Text scale="bodyS500">
                    {t('submission.review.submissionStatus', {
                        submissionStatus: submissionStatusOptions[campaign.submission_status].label,
                    })}
                </Text>
            </div>
        </div>
    )
}

export default styled(CampaignHeader)`
    display: flex;
    gap: ${({ theme }) => theme.spacing[200]};
    img {
        height: 80px;
        height: 80px;
    }
`
